import { Button } from '@circlefin/components'
import { useModalHistory } from '@circlefin/modal-router'
import { FullScreen } from '@modals/layout'
import { addressBook } from '@services/sections/lib/address-book'
import { Center } from '@shared/components/layout'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

export const ApprovalRequired: React.FC = () => {
  const { t } = useTranslation('address-book/modals')
  const { history } = useModalHistory()

  return (
    <FullScreen totalSteps={history.length + 1}>
      <Center>
        <div className="mt-4 flex w-152 flex-col text-center">
          <h2 className="type-h-page-sm">
            {t('addAddress.approvalRequired.title')}
          </h2>
          <p className="mt-8 type-body-base">
            {t('addAddress.approvalRequired.subtitle')}
          </p>
        </div>
      </Center>

      <Center className="mt-8">
        <Button.Link
          anchorComponent={Link}
          href={addressBook.route}
          size="base"
          variant="primary"
        >
          {t('addAddress.approvalRequired.backToAddressBook')}
        </Button.Link>
      </Center>
    </FullScreen>
  )
}
